module.exports = __webpack_public_path__ + "officialStatic/img/case1.4311475.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/partner/case1.png
// module id = I9rz
// module chunks = 0